import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from '@/i18n';
import './theme/common.less';
// Ant Design Vue 4.x 基础重置样式
import 'ant-design-vue/dist/reset.css';
import '@/assets/iconfont/iconfont.css';
import '@/styles/reset.less';
import { loadCore } from '@jg/qiankun-micro-tool';
import { message } from 'ant-design-vue';
import report from '@/utils/escalation';
report();
loadCore({
  business: 'Console',
  headerContainer: '#core-header-container',
});
export const prefixCls = 'jant';
message.config({ prefixCls: `${prefixCls}-message` });
createApp(App).use(router).use(i18n).mount('#app');
